import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.567 38.066l-6.533-6.533c-.4-.4-.889-.6-1.467-.6-.578 0-1.089.222-1.533.667-.4.4-.6.889-.6 1.466 0 .578.2 1.067.6 1.467l8.133 8.2c.4.4.867.6 1.4.6.534 0 1-.2 1.4-.6L45.901 26.8c.444-.445.666-.956.666-1.534 0-.577-.222-1.088-.666-1.533a2.14 2.14 0 00-1.567-.567c-.6.023-1.1.234-1.5.634L28.567 38.066zm3.934 20.6c-3.645 0-7.09-.7-10.334-2.1-3.244-1.4-6.078-3.31-8.5-5.733-2.422-2.422-4.333-5.256-5.733-8.5-1.4-3.244-2.1-6.689-2.1-10.333 0-3.69.7-7.156 2.1-10.4 1.4-3.245 3.311-6.067 5.733-8.467 2.423-2.4 5.256-4.3 8.5-5.7 3.245-1.4 6.69-2.1 10.334-2.1 3.689 0 7.155.7 10.4 2.1 3.244 1.4 6.066 3.3 8.466 5.7 2.4 2.4 4.3 5.222 5.7 8.467 1.4 3.244 2.1 6.71 2.1 10.4 0 3.644-.7 7.089-2.1 10.333-1.4 3.244-3.3 6.078-5.7 8.5-2.4 2.422-5.222 4.333-8.466 5.733-3.245 1.4-6.712 2.1-10.4 2.1z"
        fill={props.color || '#2BA168'}
      />
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  any,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgCheckCircle = _style(SvgIcon)

export default SvgCheckCircle
